import { render, staticRenderFns } from "./BaseNote.vue?vue&type=template&id=0a97a3e2&"
import script from "./BaseNote.vue?vue&type=script&lang=js&"
export * from "./BaseNote.vue?vue&type=script&lang=js&"
import style0 from "./BaseNote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports